<!-- =========================================================================================
  File Name: SponsorEdit.vue
  Description: Sponsor Edit Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Webspiders
  Author URL: https://www.webspiders.com
========================================================================================== -->
<style lang="scss">
.header-custome{margin-bottom: 15px; padding-left: 2px;}
</style>
<template>
  <div id="page-user-edit">
    <div class="header-custome">
      <h3>Add Mail Template</h3>
    </div>
    <vx-card v-if="mailtpl_data">
      <div slot="no-body" class="tabs-container px-6 pt-6">
        <vs-tabs v-model="activeTab" class="tab-action-btn-fill-conatiner">
          <vs-tab label="Mail Template" icon-pack="feather" icon="icon-user">
            <div class="tab-text">
              <edit-tab-account class="mt-4" :data="mailtpl_data" />
            </div>
          </vs-tab>
          <vs-tab label="Short Codes" icon-pack="feather" icon="icon-user">
            <div class="tab-text">
              <short-codes :data="shortcodes_data" />
            </div>
          </vs-tab>
          
        </vs-tabs>
      </div>
    </vx-card>
  </div>
</template>

<script>
import EditTabAccount from "./EditTabAccountJson.vue";
import ShortCodes from "./ShortCodes.vue";
// Store Module
import moduleMailtplManagement from "@/store/mailtpl-management/moduleMailtplManagement.js";

export default {
  components: {
    EditTabAccount,
    ShortCodes
  },
  data() {
    return {
      mailtpl_data: null,
      shortcodes_data: [],
      activeTab: 0
    };
  },
  watch: {
    activeTab() {
      this.fetch_mailtpl_data();
    }
  },
  methods: {
    fetch_mailtpl_data() {
        this.$store
          .dispatch("mailtplManagement/fetchMailtpl", {
            DocName: null,
            CollectionName: null,
          })
          .then((res) => {
            this.$store
              .dispatch("mailtplManagement/fetchGeneralSettings")
              .then((settings) => {
                this.mailtpl_data = res.data;
                this.mailtpl_data.projectId = settings.UnlayerProjectId
                  ? settings.UnlayerProjectId
                  : 6232;
              });
          });
    },
    fetch_shortcodes_data() {
      this.$store.dispatch("mailtplManagement/fetchShortCodes").then((res) => {
        this.shortcodes_data = res.data;
      });
    },
  },
  created() {
    //debugger;
    // Register Module UserManagement Module
    if (!moduleMailtplManagement.isRegistered) {
      this.$store.registerModule("mailtplManagement", moduleMailtplManagement);
      moduleMailtplManagement.isRegistered = true;
    }
    this.fetch_mailtpl_data();
    this.fetch_shortcodes_data();
  }
};
</script>